<template>
    <div id="login">
        <AppHeader />
        <div id="container" class="card">
            <h1>{{ $t("login.login_title") }}</h1>
            <div v-if="errorMessage" class="alert alert-danger fade show" role="alert">
                {{ errorMessage }}
            </div>
            <form @submit.prevent>
                <div class="form-group">
                    <label for="email1">{{ $t("login.email_label") }}</label>
                    <input class="form-control" v-model.trim="loginForm.email" type="email" :placeholder="$t('login.email_place_holder')" id="email1" />
                </div>

                <div class="form-group">
                    <label for="password1">{{ $t("login.password_label") }}</label>
                    <input class="form-control" v-model.trim="loginForm.password" type="password" :placeholder="$t('login.password_place_holder')" id="password1" />
                </div>
            </form>

            <div class="extras">
                <button @click="login" class="btn btn-primary">{{ $t("login.log_in_button") }}</button>
                <!--<a href="#">{{ $t("login.forgot_password_button") }}</a>
                <a>{{ $t("login.create_account_button") }}</a>-->
            </div>
        </div>
    </div>
</template>

<script>
import AppHeader from '@/components/ui/AppHeader.vue'
import AuthenticationService from '@/service/AuthenticationService'

export default {
    components: {
        AppHeader
    },
    data() {
        return {
            loginForm: {
                email: '',
                password: ''
            },
            errorMessage: null
        }
    },
    methods: {
        login() {
            const authenticationService = new AuthenticationService(this.$store);
            authenticationService.login(this.loginForm.email, this.loginForm.password).then(() => {
                this.$router.push('/admin/overview')
            }).catch((error) => {
                switch(error.code) {
                    case "auth/wrong-password":
                        this.errorMessage = this.$t("login.errors.wrong_password");
                        break;
                    case "auth/user-not-found":
                        this.errorMessage = this.$t("login.errors.user_not_found");
                        break;
                    case "auth/invalid-email":
                        this.errorMessage = this.$t("login.errors.invalid_email");
                        break;
                    default:
                        this.errorMessage = this.$t("login.errors.unknown_error");
                        console.log(error);
                        break;
                }
            });
        }    
    }
}
</script>

<style scoped>
#login {
    background-color: #f8f8f8;
    width: 100%;
}

#container {
    margin: 100px auto;
    padding: 50px;
    width: 400px;
}

#container h1 {
    margin-bottom: 16px;
}

#container form {
    text-align: left;
}

.form-group {
    margin: 16px 0px;
}

.extras a {
    display: block;
    margin: 16px 0px;
}
</style>